var AppModeService = /** @class */ (function () {
    function AppModeService() {
    }
    Object.defineProperty(AppModeService, "isDevelopmentMode", {
        get: function () {
            return location.port === '4200';
        },
        enumerable: true,
        configurable: true
    });
    return AppModeService;
}());
export { AppModeService };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/services/app.mode.service.ts.pre-build-optimizer.js